// Falcon.ai ブランドサイト（初期バージョン）
// 使用技術：React + TailwindCSS

import React from "react";
import falconBg from "./assets/falcon-logo-merged.png";
import falconRedEye from "./assets/eye_only_overlay_fixed.png";
import "./index.css";
const version = "1.0.0";
const releaseDate = "2025.6.25 11:19:00 JST"

export default function FalconSite() {
  return (
    <div className="bg-black text-white min-h-screen font-sans">
      {/* ヒーローセクション */}
      <section className="py-10 relative flex flex-col items-center justify-center text-center py-31 px-4">
        {/* 背景フェードインレイヤー */}
        <div
          className="absolute inset-0 bg-no-repeat bg-center bg-contain animate-fade-loop"
          style={{ backgroundImage: `url(${falconBg})` }}
        ></div>
        <div className="absolute inset-0 z-20 pointer-events-none animate-eye-overlay"
          style={{ backgroundImage: `url(${falconRedEye})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain"
          }}
        ></div>

        {/* テキストレイヤー */}
        <div className="relative z-10">
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight my-8">
            The Intelligence Behind Every Decision
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mb-8 justify-center text-center text-gray-300 mx-auto">
            Autonomous AI-Driven Crypto Trading Framework — Quiet No Longer
          </p>

          <div className="pt-24 px-6 max-w-5xl mx-auto">
            <h2 className="text-3xl font-semibold mb-6">What is "Falcon AI"?</h2>
            <p className="text-gray-300 leading-loose">
              “falcon.ai” is a structured intelligence framework centered on a single Commander.
              It unifies self-organizing AI agents, human-calibrated reasoning, and non-linear market perception.
              Not a trading system, but a cognitive architecture—built to act, adapt, and remain undetected—it silently accumulates advantage through psychological inference and structural asymmetry.
              “falcon.ai” is not for public deployment.
              It is a private command system for autonomous strategic cognition and long-term market engagement.
            </p>
            <span className="block mt-2">
              <a href="/story" className="underline text-white hover:text-[#AF802B] ml-1">Read the story</a>
            </span>
          </div>
        </div>
      </section>

      {/* システム構成 */}
      <section className="py-6 px-8 bg-gray-900">
        <div className="w-full">
          <h2 className="text-3xl font-semibold mb-6 text-center text-gray-300">System Structure</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-black p-6 rounded shadow">
              <h3 className="text-xl font-bold mb-2 text-white">Top Trader Cognitive Synchronization System</h3>
              <p className="text-gray-400">Synchronizes the decision-making logic of expert traders into the system in real time.</p>
            </div>
            <div className="bg-black p-6 rounded shadow">
              <h3 className="text-xl font-bold mb-2 text-white">Autonomous Goal-Oriented Multi-Agent Decision Core</h3>
              <p className="text-gray-400">A dynamic, AI-driven architecture that distributes objectives across autonomous agents.</p>
            </div>
            <div className="bg-black p-6 rounded shadow">
              <h3 className="text-xl font-bold mb-2 text-white">Real-Time Market Ingestion and Analysis Engine</h3>
              <p className="text-gray-400">Continuously ingests market data and identifies actionable patterns with millisecond latency.</p>
            </div>
            <div className="bg-black p-6 rounded shadow">
              <h3 className="text-xl font-bold mb-2 text-white">Reinforcement Learning-Based Trading Bot Cluster</h3>
              <p className="text-gray-400">A swarm of trading bots trained through RL in sandbox simulations and deployed adaptively.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 公開メッセージ */}
      <section className="py-10 px-6 max-w-5xl mx-auto justify-center text-center">
        <h2 className="text-3xl font-semibold mb-6">We Were Silent. Until Now.</h2>
        <p className="text-gray-300 leading-loose">
          Falcon has operated in silence, under the radar. Today, we reveal our presence. Tomorrow, we shift the paradigm.
        </p>
      </section>

      {/* アクイジション案内 */}
      <footer className="py-8 px-6 bg-gray-950 flex justify-center text-white text-sm">
        <p>
          Contact us : <a href="mailto:contact@falcon.ai" className="underline">contact@falcon.ai</a>
        </p>
      </footer>
        <p className="text-black leading-loose justify-center text-center">Version {version} - Released: {releaseDate}</p>
    </div>
  );
}